// @flow
import React, {Fragment} from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {STAR__16} from '@homeaway/svg-defs';
import Tooltip from '@homeaway/react-tooltip';

import type {BadgeShape as Badge} from '../Hit/Hit';

import './WebRatingBadge.less';

type WebRatingBadgesProps = {
    badge: Badge,
    renderTooltip?: boolean,
    renderStarIcon?: boolean
};

export default function WebRatingBadge({
    badge,
    renderTooltip = false,
    renderStarIcon = false
}: WebRatingBadgesProps) {
    return (
        <Fragment>
            {!!renderStarIcon && (
                <SVGIcon className="Rating__star" markup={STAR__16} />
            )}
            <span className="WebRatingBadge">
                {renderTooltip ? (
                    <Tooltip
                        wrapperClassName="WebRatingBadge"
                        centered
                        trigger="hover"
                        tooltipType="popover"
                        content={badge.helpText}
                        placement="top"
                    >
                        {badge.name}
                    </Tooltip>
                ) : (
                    badge.name
                )}
            </span>
        </Fragment>
    );
}
